import React, { FC, memo } from "react";
import { isString, isObject, isNumber, isNil } from "lodash";
import clsx from "clsx";
import { Controller } from "react-hook-form/dist/index.ie11";
import { MenuPlacement } from "react-select";

import { useSetSelectOption } from "~/hooks/SelectValue";

import CustomSelect from "./CustomSelect";

import s from "./Select.less";
import Select from "~/shared/ui/Fields/Select";

interface IProps {
  label?: string;
  name: string;
  type?: string;
  control?;
  loading?: boolean;
  error?: string;
  disabled?: boolean;
  vertical?: boolean;
  desc?: boolean;
  isMulti?: boolean;
  isHeight?: boolean;
  isSearchable?: boolean;
  required?: boolean;
  isNoLabel?: boolean;
  menuCustom?: boolean;
  customClassName?: string;
  optionObjects?: object[];
  defaultValue?: object;
  onChanges?;
}

const SelectZD: FC<IProps> = ({
  label,
  name,
  type,
  control,
  error,
  loading = false,
  disabled = false,
  vertical = false,
  menuCustom = false,
  isHeight = false,
  required = false,
  isSearchable = false,
  isNoLabel = false,
  desc = false,
  isMulti = false,
  onChanges,
  customClassName = "",
  optionObjects = [],
  defaultValue = {},
}) => {
  const selectOption = useSetSelectOption();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={
        defaultValue || optionObjects[0] || selectOption("common.not_selected")
      }
      render={({ value, onChange }) => (
        <div
          className={clsx({
            [s.s_select]: true,
            [s.select_vertical]: vertical,
            [s.disabled]: disabled,
            [s.no_label]: !label,
            [s.isNoLabel]: isNoLabel,
            [customClassName]: true,
          })}
        >
          {label && <label>{label}</label>}
          <div
            className={clsx(s.desc, {
              [s.desc_select]: desc,
            })}
          >
            <CustomSelect
              options={optionObjects}
              value={
                isString(value) || isNumber(value)
                  ? selectOption(value, type)
                  : isObject(value) && value
              }
              onChange={onChanges || onChange}
              error={error}
              isMulti={isMulti}
              isNoLabel={isNoLabel}
              isHeight={isHeight}
              menuCustom={menuCustom}
              isSearchable={isSearchable}
              disabled={disabled}
              isLoading={loading}
              required={required}
            />
          </div>
        </div>
      )}
    />
  );
};
export default memo(SelectZD);
